/**
 * Validates that a redirect target is a safe relative path.
 * Rejects absolute URLs, protocol-relative URLs, and scheme-based URLs
 * to prevent open redirect attacks.
 *
 * Returns the path if safe, or the fallback otherwise.
 */
export function safeRedirectPath(target: string | null | undefined, fallback = "/"): string {
  if (!target) return fallback;

  // Must start with exactly one "/" and not be protocol-relative ("//")
  if (!target.startsWith("/") || target.startsWith("//")) return fallback;

  // Reject anything with a scheme (e.g. "http:", "javascript:")
  if (/^[a-z][a-z0-9+\-.]*:/i.test(target)) return fallback;

  return target;
}
